import { Tooltip } from '@material-ui/core';
import React from 'react';

import { getNumberUnit } from '@utils/Util';

const TargetAndAchievementGraph = ({ activitySummary }) => {
	const handlePercentage = (target, achievement) => {
		return ((achievement / target) * 100).toFixed(2);
	};

	const getPercentBetweenTwoNumbers = (n1, n2) => {
		const percentage = ((n2 - n1) / n1) * 100;
		return Math.abs(percentage.toFixed(2));
	};

	const renderAchievement = () => {
		if (activitySummary?.projectedAmount >= activitySummary?.acheivedAmount) {
			return (
				<>
					<Tooltip
						title={
							<div>
								<p>Achievement : ${getNumberUnit(activitySummary?.acheivedAmount)}</p>
								<p>
									Percentage :{' '}
									{handlePercentage(
										activitySummary?.projectedAmount,
										activitySummary?.acheivedAmount
									)}
									%
								</p>{' '}
							</div>
						}
						placement="top"
						arrow
					>
						<div
							className="achivement"
							style={{
								width: `${handlePercentage(
									activitySummary?.projectedAmount,
									activitySummary?.acheivedAmount
								)}%`
							}}
						/>
					</Tooltip>
					<Tooltip
						title={
							<div>
								<p>Target : ${getNumberUnit(activitySummary?.projectedAmount)}</p>
							</div>
						}
						placement="top"
						arrow
					>
						<div
							className="target"
							style={{
								width: `${
									100 -
									handlePercentage(
										activitySummary?.projectedAmount,
										activitySummary?.acheivedAmount
									)
								}%`
							}}
						/>
					</Tooltip>
				</>
			);
		} else if (
			(!activitySummary?.projectedAmount || activitySummary?.projectedAmount === 0) &&
			activitySummary?.acheivedAmount > 0
		) {
			return (
				<>
					<Tooltip
						title={
							<div>
								<p>Achievement : ${getNumberUnit(activitySummary?.acheivedAmount)}</p>
								<p>Percentage : N/A</p>{' '}
							</div>
						}
						placement="top"
						arrow
					>
						<div
							className="achivement"
							style={{
								width: `100%`
							}}
						/>
					</Tooltip>
					<Tooltip
						title={
							<div>
								<p>Target : ${getNumberUnit(activitySummary?.projectedAmount)}</p>
							</div>
						}
						placement="top"
						arrow
					>
						<div
							className="target"
							style={{
								width: `${
									100 -
									handlePercentage(
										activitySummary?.projectedAmount,
										activitySummary?.acheivedAmount
									)
								}%`
							}}
						/>
					</Tooltip>
				</>
			);
		} else {
			return (
				<>
					<Tooltip
						title={
							<div>
								<p>Target : ${getNumberUnit(activitySummary?.projectedAmount)}</p>
							</div>
						}
						placement="top"
						arrow
					>
						<div
							className="target"
							style={{
								width: `${handlePercentage(
									activitySummary?.acheivedAmount,
									activitySummary?.projectedAmount
								)}%`
							}}
						/>
					</Tooltip>
					<Tooltip
						title={
							<div>
								<p>Achievement : ${getNumberUnit(activitySummary?.acheivedAmount)}</p>
								<p>
									Percentage :{' +'}
									{handlePercentage(
										activitySummary?.projectedAmount,
										activitySummary?.acheivedAmount
									)}
									%
								</p>{' '}
							</div>
						}
						placement="top"
						arrow
					>
						<div
							className="achivement"
							style={{
								width: `${getPercentBetweenTwoNumbers(
									activitySummary?.acheivedAmount,
									activitySummary?.projectedAmount
								)}%`
							}}
						/>
					</Tooltip>
				</>
			);
		}
	};

	return <div className="target-achivement mb-2">{renderAchievement()}</div>;
};

export default TargetAndAchievementGraph;
